module.exports = __webpack_public_path__ + "static/media/choose-def.2b37e599.png";